// IQD money formatter — thousands separators, rounded, no minor units.
// Parity with the handoff's window.SC_FORMAT.iqd.
const iqdFormatter = new Intl.NumberFormat('en-US');

export const iqd = (n: number): string =>
  iqdFormatter.format(Math.round(n || 0));
